export const FILE_TYPE_IMAGE = "image";

export const FILE_TYPE_VIDEO = "video";
